<template>
    <div>
      <statement-list></statement-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>